import { useIntl } from 'react-intl';
import { lowerCaseAllLetter } from 'src/utils/string';

import WelcomeImage from '../image/welcome.png';
import OnboardingHeader from '../OnboardingHeader';
import OnboardingFooter from '../OnboardingFooter';

const WelcomeStep = ({ onNext, currentStep, totalSteps }) => {
  const intl = useIntl();

  const handleContinue = () => {
    const dadosAtualizados = {
      aceitouTermosUso: true,
    };

    onNext(dadosAtualizados);
  };

  const handleLinkTerms = () => {
    if (intl.locale === 'pt-br') return 'https://actiosoftware.com/privacidade';
    if (intl.locale === 'es') return 'https://actiosoftware.com/es/privacidad';

    return 'https://actiosoftware.com/en/privacy-policy';
  };

  const renderContent = () => (
    <>
      <img
        src={WelcomeImage}
        alt="Bem-vindo ao Actio"
        style={{ maxWidth: 320, marginTop: 60, marginBottom: 22 }}
      />

      <h4 style={{ marginBottom: 12, color: '#0e0e0fff' }}>
        <strong>
          {intl.formatMessage({ id: 'iniciarOnboardGamificado' })}
        </strong>
      </h4>

      <p style={{ maxWidth: 520, color: '#6B7280', marginBottom: 12 }}>
        {intl.formatMessage({ id: 'instrucaoInicialOnboard' })}
      </p>

      <p style={{ fontSize: 14, color: '#6B7280' }}>
        {intl.formatMessage({ id: 'aoContinuar' })}{' '}
        <a
          href={handleLinkTerms()}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#4372C4', textDecoration: 'none' }}
        >
          <strong>
            {lowerCaseAllLetter(intl.formatMessage({ id: 'termosDeUso' }))}
          </strong>
        </a>
        .
      </p>
    </>
  );

  return (
    <div
      style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
    >
      <OnboardingHeader currentStep={currentStep} totalSteps={totalSteps} />

      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ width: 650, justifyContent: 'center'}}>{renderContent()}</div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: 650 }}>
          <OnboardingFooter showBack={false} onPrimaryAction={handleContinue} />
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep;
